module.exports = __webpack_public_path__ + "img/icon-supplier-conversations-selected.2951a8e8.svg";